/**
 * The external Clerk production instance is first-party only on the
 * `metalui.co.uk` root domain. Keep legacy dashboard and raw Replit deployment
 * URLs off unsupported origins before React mounts Clerk there.
 */
const UNSUPPORTED_CLERK_HOSTS = new Set([
  "dashboard.everydaybullion.co.uk",
  "stock-manager--everydayb.replit.app",
]);
const EVERYDAY_BULLION_APP_ORIGIN = "https://everyday-bullion.metalui.co.uk";

export interface BrowserLocation {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}

/**
 * Return the canonical tenant URL for an unsupported production host,
 * preserving the full in-app destination. Other hosts are deliberately left
 * alone so local development and other tenant subdomains are unaffected.
 */
export function getLegacyClerkDomainRedirect(
  location: BrowserLocation,
): string | null {
  if (!UNSUPPORTED_CLERK_HOSTS.has(location.hostname.toLowerCase())) return null;
  return `${EVERYDAY_BULLION_APP_ORIGIN}${location.pathname}${location.search}${location.hash}`;
}